import { render } from "./CreatureTable.vue?vue&type=template&id=31b0811f&scoped=true"
import script from "./CreatureTable.vue?vue&type=script&lang=js"
export * from "./CreatureTable.vue?vue&type=script&lang=js"

import "./CreatureTable.vue?vue&type=style&index=0&id=31b0811f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b0811f"]])

export default __exports__